<template>
  <div :class="['productPageV2']">

    <div class="proHero">
        <prohero>
            <div class="heroContent">
                <img src="lynx/img/lynx.svg" class="psLogo"/>
                <div class="psTitle">
                    NextGen Simplicity.
                </div>    
            </div>
        </prohero>
    </div>

    <div>
      <prohl></prohl>
    </div>

    <div style="padding:3vw 5vw 1vw 5vw">
      <prowhy></prowhy>
    </div>

    <!-- //////////// TECHNICAL INFORMATION ////////////-->
    <!-- //////////// TECHNICAL INFORMATION ////////////-->
    <!-- //////////// TECHNICAL INFORMATION ////////////-->
    
    <div class="proSection Technical">
        <div class="content">
            <div class="psTitle">
              Technical Information              
            </div>    
            <div class="techCont" v-if="minisite_data">
              <div class="techTabsArea">
                <div class="techTabs2">
                  <ul>
                    <li @click="featureIndex=index"
                      v-for="(item,index) in featuresMenu" :key="'feature_'+index" 
                      :class="[index == featureIndex ? 'selected':'']">
                      <span>{{item}}</span>
                    </li>
                  </ul>
                </div>
              </div>

                  <div class="tabsContentArea">
                    <div :class="['tabPanel',featureIndex==0 ? 'visible':'']">
                      <techrange :sectionDataIndex="2"></techrange>
                    </div>
                    <div :class="['tabPanel',featureIndex==1 ? 'visible':'']">
                      <techinfo :sectionDataIndex="3" ></techinfo>
                    </div>
                    <div :class="['tabPanel',featureIndex==2 ? 'visible':'']">
                      <techfeat></techfeat>
                    </div>
                    <div :class="['tabPanel',featureIndex==3 ? 'visible':'']">
                      <techpackage :sectionDataIndex="8"></techpackage>
                    </div>
                    <div :class="['tabPanel',featureIndex==4 ? 'visible':'']">
                      <techdrilling :sectionDataIndex="4"></techdrilling>
                    </div>
                  </div>
              </div>
          </div>
    </div>

    <div class="proSection Technical">
        <div class="technicalContent">
            <div class="psTitle">Clinical Cases</div>
            <div>
              <hp-cases 
                :theme="'casesInProduct'" 
                :sectionData = "tempCasesData"></hp-cases>
            </div>
        </div>
    </div>

    <div class="proSecSep"></div>

    <div class="proSection Technical">
        <div class="technicalContent">
            <div class="psTitle">Article Library</div>
            <div>
              <hp-cases 
                :titleFontCss = "'proArticle_TitleFs'"
                :showSummaryFirst = "false"
                :showThumb = "false"
                :theme="'articlesInProduct'" 
                :sectionData = "tempArticlesData"></hp-cases>
            </div>
        </div>
    </div>

    



  </div>
</template>

<style>
    .productPageV2
    {
        width: 100%;
        min-height: 50vh;
        position: relative;
        top: 30px;
        padding-bottom: 10vw;
        /* top: -100px; */
    }



    .proSection
    {
        width: 100vw;
        /* height: calc(100vh - 90px);         */
        height: 100vh;
        position: relative;
    }
    .proSection.sticky
    {
      height: 200vh;
      position: sticky;
    }

    .proHero
    {
      width: 100vw;
      background: transparent;
      height: calc(100vh - 120px);
      position: relative;

    }
    .heroContent
    {
      height: auto;
      height: auto;
      margin: auto;
      width: 90vw;
      background: transparent;
    }


    .proSection .background
    {
        position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;
        background-color: #202020;
        z-index: 100;
    }
    .proSection .background video
    {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

    .proSection .content
    {
        position: sticky;
        top: 0px;left: 0px;
        width: 100%;
        height: 100vh;
        padding: 0px 5vw;

        display: flex;
        flex-direction: column;   /* stack vertically */
        justify-content: center;  /* center vertically */
        align-items:flex-start;      /* center horizontally */


    }
    .psLogo
    {
      width: auto;
      height: 6vw;
      text-align: left;
    }
    .psTitle{
        width: 40vw;
        font-size: 42px;color: #202020;
        letter-spacing: -1.5px !important;
    }
    .psDesc{
        padding-top: 20px;
        width: 35vw;
        font-size: 16px;
        color: #202020;
        display: block;        
    }


    .proSection.Technical
    {
      height: auto;
      padding-top: 3vw;
    }
    .technicalContent
    {
        position:initial;
        height: auto;
        display: block; 
        padding: 4vw 5vw 0 5vw;
    }
    .proSecSep
    {
        max-height: 1px;
        line-height: 1px;
        border-bottom: solid 1px #ccc;
        width: 90vw;
        margin: auto;
    }


    .techTabs
    {
      margin-top: 30px;
      padding: 36px 60px 60px 40px;      
      border-radius: 20px;
      width: auto;
      display: inline-block;
      background: #6b6b6b;border: solid 0px #202020;
    }
    .techTabs ul
    {
      list-style: none;
      display: flex;
      flex-direction: row;
      column-gap: 40px;
      flex-shrink: 0;
    }
    .techTabs li
    {
      color: #fff;
      font-weight: 300 !important;
      opacity: 0.7;
      cursor: pointer;
    }
    .techTabs li.selected
    {
      color: #fff;
      font-weight: 500 !important;
      opacity: 1;
    }

    .techTabsArea
    {
      display: flex;
      align-items: center;
      padding: 4vw 0 2vw 0;
    }

    .techTabs2
    {
      padding: 20px 40px;      
      border-radius: 80px;
      width: auto;
      display: inline-block;
      background: transparent;
      border: solid 1px #202020;
      width: auto;
      margin: auto;
    }
    .techTabs2 ul
    {
      list-style: none;
      display: flex;
      flex-direction: row;
      column-gap: 40px;
      flex-shrink: 0;
      margin: auto;
      width: 100%;
    }
    .techTabs2 li
    {
      opacity: 0.4;
      cursor: pointer;
    }
    .techTabs2 li.selected
    {
      opacity: 1;
    }    
    .techTabs2 li span
    {
      color: #202020;
      font-weight: 400 !important;
    }


    .tabsContentArea
    {
      /* border: solid 2px red; */
      height: 40vw;
    }







    .techCont
    {
      /* border: solid 1px #202020;background-color: #fff; */
      border: solid 0px #202020;
      /* background-color: #f9f9f9; */
      background-color: #f9f9f9;
      width: 100%;
      height: 50vw;     
      border-radius: 20px;      
      text-align: center;  
      margin-top: 20px;
      display: block;
    }
    .tabPanel
    {
      width: 100%;
      height: 100%;
      display: none;
    }
    .tabPanel.visible
    {
      display: block;
    }



    @media screen and (max-width: 815px)
    {
/*       .technicalContent .psTitle,
      .heroContent .psTitle
 */      
      .productPageV2 .psTitle
      {
        font-size: 25px;
        width: 100%;
        font-weight:300 !important;
      }
      .psLogo
      {
        height: 12vw;
        width: auto;
      }
      .heroContent
      {
        width: 76vw;
      }
      .proHero{
        height: 70vw;
      }
      .techTabs2
      {
        padding: 10px 10px;      
        border-radius: 80px;
      }
      .techTabs2 ul
      {
        column-gap: 10px;
        flex-shrink: 0;
        margin: auto;
        width: 100%;
      }
      .techTabs2 li
      {
        font-size: 12px;
        display: flex;
        align-items: center;
      }      
    }


</style>



<script>
    import prohero     from "@/views/products/com/ProHero.vue";
    import prohl     from "@/views/products/com/ProHighlights.vue";
    import prosection     from "@/views/products/com/ProSection.vue";
    import prowhy     from "@/views/products/com/ProWhy.vue";
    import techrange      from "@/views/products/com/TechRange.vue";
    import techinfo      from "@/views/products/com/TechInfo.vue";
    import techfeat      from "@/views/products/com/TechFeatures.vue";
    import techpackage      from "@/views/products/com/TechPackage.vue";
    import techdrilling      from "@/views/products/com/TechDrilling.vue";
    import hpCases from '@/views/home/hpCases.vue';

  /* import SeqSection from "./SeqSection.vue";  */
  import { mapActions, mapState } from "vuex";  
  export default 
  {
    components:
    {
        prohl,prowhy,prohero,prosection,techrange,techinfo,techfeat,techpackage,techdrilling,hpCases
    },
    data(){
      return{
        tempArticlesData:
        {
            items:[
              {parent_id:520,title:"Research Overview: C1 Implants",subtitle: "This research overview document presents recent clinical studies evaluating the performance of the MIS C1 implant system.", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Clinical and Radiographic assessment of circular versus triangular cross-section neck implants in the posterior maxilla: Five-year follow-up of a Randomized Controlled Trial",subtitle: "Alexandre Hurtgen; Laurence Seidel; Lou Li Manni; Lemmy Liegeois; Geoffrey Lecloux; France Lambert", img: "/Research-And-Development/Research-Library/thumbs/digital-wf.jpeg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Effects of customized CAD/CAM abutments on cytokine levels in peri‑implant crevicular fluid during early implant healing: a pilot study",subtitle: "Christian Wehner; Gabor Fürst; Tom Vaskovich; Oleh Andrukhov; Christoph Vasak; Andreas Moritz; Xiaohui Rausch‑Fan", img: "/Research-And-Development/Research-Library/thumbs/Federico_Rivara.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"The effect of triangular cross-section neck design on crestal bone stability in the anterior mandible: A randomized, controlled, split-mouth clinical trial",subtitle: "Berkay Tokuc; Bahadır Kan", img: "Research-And-Development/Research-Library/thumbs/Radu_Pop.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Research Overview: C1 Implants",subtitle: "This research overview document presents recent clinical studies evaluating the performance of the MIS C1 implant system.", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Clinical and Radiographic assessment of circular versus triangular cross-section neck implants in the posterior maxilla: Five-year follow-up of a Randomized Controlled Trial",subtitle: "Alexandre Hurtgen; Laurence Seidel; Lou Li Manni; Lemmy Liegeois; Geoffrey Lecloux; France Lambert", img: "/Research-And-Development/Research-Library/thumbs/digital-wf.jpeg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Effects of customized CAD/CAM abutments on cytokine levels in peri‑implant crevicular fluid during early implant healing: a pilot study",subtitle: "Christian Wehner; Gabor Fürst; Tom Vaskovich; Oleh Andrukhov; Christoph Vasak; Andreas Moritz; Xiaohui Rausch‑Fan", img: "/Research-And-Development/Research-Library/thumbs/Federico_Rivara.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"The effect of triangular cross-section neck design on crestal bone stability in the anterior mandible: A randomized, controlled, split-mouth clinical trial",subtitle: "Berkay Tokuc; Bahadır Kan", img: "Research-And-Development/Research-Library/thumbs/Radu_Pop.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"* The effect of triangular cross-section neck design on crestal bone stability in the anterior mandible: A randomized, controlled, split-mouth clinical trial",subtitle: "Berkay Tokuc; Bahadır Kan", img: "Research-And-Development/Research-Library/thumbs/Radu_Pop.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] }
        ]},
        tempCasesData:
          {
            items:[
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading, Single Tooth Immediate Implantation and Immediate Loading Workflow with MIS C1 Implant",subtitle: "Dr. Stavros Pelekanos", img: "/Research-And-Development/Research-Library/thumbs/digital-wf.jpeg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Research-And-Development/Research-Library/thumbs/Federico_Rivara.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "Research-And-Development/Research-Library/thumbs/Radu_Pop.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "Research-And-Development/Research-Library/thumbs/Alon_Schifter_C1-guided1.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Research-And-Development/Research-Library/thumbs/Federico_Rivara.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "Research-And-Development/Research-Library/thumbs/Radu_Pop.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "Research-And-Development/Research-Library/thumbs/Alon_Schifter_C1-guided1.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] },
              {parent_id:520,title:"Live Surgery of Full Arch Placement of 6 Implants and Immediate Loading with a Stackable Prosthetic Guide",subtitle: "Dr. Stavros Pelekanos", img: "/Education/learn-online/Lectures/surgery.jpg", video: "https://player.vimeo.com/video/1128850416?h=5a09b9894c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479", children: [] }
          ]},
        featuresMenu:['Implant range','Dimensions','Features','Package Contents','Drilling Procedure'],
        featureIndex:0,
        showProSideMenu:true,
        sectionsPos:[0,0,0,0,0],
        visibleSection:0,
        activeIndex: 0,
        children:[],
        sectionsProgresses:[
            {prog:0,time:0,videoID:'proVid0'},
            {prog:0,time:0,videoID:'proVid1'}
        ],
        progress:100,
        minisite_ready:false,        
        minisite_data:null,
        minisite_dictionary:null,
      }
    },  
    computed: {
        //...mapState(["siteData","siteDataReady","siteReady","minisite_VisibleSection","pageLayoutData"]),
    },
    created()  
    {            
        var vm = this;
        //this.setPageReady(false);
        this.initScrollListener();
        setTimeout(() => {
          vm.loadData();  
        }, 1000);
        
        //this.setPageReady(true);
    },
    mounted()
    {
        var vm=this;
        //vm.progress=20000;
        vm.initScrollListener();
    },

    methods:
    {
      ...mapActions(["setMinisiteData","setMinisiteDic","xSetPlatform","initRouteByCid","setPageReady"]),
      onViewChange(data)
      {
          if(data.index==2)
          {
            //alert("element2 visible:"+data.val);
          }
          //this.sectionsPos[data.index] = data.val;
      },
      getLangByRoute()
      {
        let lc = this.$route.params.lang;
        if(lc == undefined){lc="en";}
        return lc;
      },
      loadData() 
      {
        //let lc = this.getLangByRoute();                
        this.loadSiteData("site_data.json");
      },
      loadSiteData(fileName)
      {
        var vm = this;
        //vm.loadProductData();        
        //LOAD CONTENTS FROM JSON           
        var APP_SITE_NAME = "lynx";//var APP_SITE_NAME = "lance";
        var apiURL = "content/"+APP_SITE_NAME+"/data/"+fileName;//e.g:"/site_data.json";
        fetch(apiURL, 
        {
            method: "GET",cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
        })
        .then(function(response){ return response.json();})
        .then(function(response){
            if(fileName=="site_data.json"){
              vm.minisite_data = response;
              vm.setMinisiteData(response);
              vm.loadSiteData("site_dictionary.json");
            }
            if(fileName=="site_dictionary.json"){
              vm.minisite_dictionary = response;
              vm.setMinisiteDic(response);
              vm.minisite_ready = true;              
            }
          }        
        );
      },        
      loadProductData()
      {
          //load the product page data from the admin 
          //clinical cases / publications / links sections
          //this.initRouteByPath(`HomeV3/${this.$route.params.locale || "global"}`);
          //page/3390
          //https://api.mis-implants.com/api/page/3390          
          //FIND THE _cid BY THE PAGE PATH (CHECK PAGE.VUE) 
          var _cid = 3390; //seven         
          this.initRouteByCid(_cid); 
          //this.initRouteByCid(item.cid);
      },

      initScrollListener() 
      {
      var vm=this;
      //let isM = isMobileScreen();
      //vm.sectionsProgresses[0]=1;
      
      setTimeout(() => {    
        //if(isMobileScreen()==false)
        //{
          //var scrollContainer = document.getElementById("mainScroller");
          //scrollContainer.addEventListener("scroll", vm.scrollHandler, false);    
        //}else
        //{
          document.addEventListener("scroll", vm.scrollHandler, false);
        //}
      }, 1000);
    },    
    scrollHandler() {      
      var vm=this;      
      vm.checkVideoSection("proHero1");
//      this.checkSectionsView();      

    },
    getElementScrollPosition(el) {
      const rect = el.getBoundingClientRect();
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom < 0) {
        // Element is completely above the viewport
        return 'above';
      } else if (rect.top > viewHeight) {
        // Element is completely below the viewport
        return 'below';
      } else {
        // Element is (at least partially) visible
        return 'visible';
      }
    },
    checkSectionsView()
    {
      var sectionElements = document.querySelectorAll(".proSection");
      var secondElement = sectionElements[1];
      var secondPos = this.getElementScrollPosition(secondElement);
      if(secondPos=='above')
      {
        this.showProSideMenu=false;
      }else{
        this.showProSideMenu=true;
      }
    },
    onSectionVisible(domSectionIndex)
    {        
        var vm=this;
        //let sectionIndex = domSectionIndex;
        //let sectionDataIndex = sectionIndex;
        //var sectionElement = document.querySelectorAll(".siteSection")[domSectionIndex];
        //this.revealSectionChildrenElements(sectionElement,domSectionIndex);
    },    
    revealSectionChildrenElements(parentElement,domSectionIndex) 
    {
      var vm=this;
      //parentElement.classList.add("active");
      //var reveals = parentElement.querySelectorAll(".reveal");
      //for (var i = 0; i < reveals.length; i++){
          //if(reveals[i].classList.contains("active")==false){
            //vm.onRevealingSection(reveals[i].id);
            //reveals[i].classList.add("active");
          //}
      //}
    },
    onRevealingSection(sectionID)
    {
        //add here specific site logic ...
    },       
    setActiveIndex(index)
    {
        this.activeIndex = index;
    },
    checkVideoSection(heroElementID)
    {
      //check a video/promo section 
      //transform the clip-path according to it's scroll view
      let heroEl= document.getElementById(heroElementID);
      if(!heroEl){
        return false;
      }
      var windowHeight = window.innerHeight;              
      var videoElementTop = heroEl.getBoundingClientRect().top;
      var videoH = heroEl.getBoundingClientRect().height;
      var topRef = videoElementTop/windowHeight;
      var transformRef = 0;                
      var minTop = 0.2;//0.3;
      var maxTop = -0.7;//-0.7;
      var range = minTop - maxTop; // range is 1                
      var inRangeRef = Math.abs(topRef - minTop);
      if(inRangeRef>1){
        inRangeRef=1;//end of transformation// the video is minimized to it's minimum
      }
      if(inRangeRef<0.1)//if(inRangeRef<0.1)
      {
        inRangeRef=0;//start the transformtion a bit later while scrolling 
      }                    
      transformRef = inRangeRef;//<<final value for transformation              

      var clipPathRef = 11 * transformRef;//10
      var clipCornerRef = 40 * transformRef;
      var clipStyle = "clip-path: inset("+clipPathRef+"% round "+clipCornerRef+"px);";
      heroEl.style = clipStyle;

      /*
      if(transformRef>0.8){
        if(heroEl.classList.contains("mini")==false){
          heroEl.classList.add("mini");//set minimized (hide conntrols)
        }
      }else{
        if(heroEl.classList.contains("mini")==true){
          heroEl.classList.remove("mini");//set maximized (show conntrols)
        }
      }          
      */  
  }
}
}
</script>


